module.exports = __webpack_public_path__ + "static/media/publish.bf7a4e32.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/publish.png
// module id = 1501
// module chunks = 0